import { Handle, Position } from '@xyflow/react';
import { Clock } from 'lucide-react';
import { type ActionNodeData } from '../../../types/node-data';
import { formatDuration } from '../../../utils/format';

export const ActionNode = ({ data, selected }: { data: ActionNodeData; selected?: boolean }) => {
  const bgColor = selected || data.selected ? 'bg-blue-200' : 'bg-blue-50';
  const borderColor = selected || data.selected ? 'border-blue-400' : 'border-gray-300';

  return (
    <div
      className={`px-3 py-2 rounded border ${borderColor} 
      ${bgColor} min-w-[150px]`}
    >
      <Handle type='target' position={Position.Left} />
      <div className='text-sm font-medium text-slate-800'>{data.label}</div>
      {data.duration !== undefined && (
        <div className='text-xs text-slate-600 flex items-center gap-1'>
          <Clock className='w-3 h-3' />
          {formatDuration(data.duration)}
        </div>
      )}
      {data.category && (
        <div
          className='text-xs bg-blue-200 text-blue-800 px-1 rounded 
          inline-block'
        >
          {data.category}
        </div>
      )}
      <Handle type='source' position={Position.Right} />
    </div>
  );
};
